import { render, staticRenderFns } from "./Home_advice_lg.vue?vue&type=template&id=01469cf0&scoped=true&"
import script from "./Home_advice_lg.vue?vue&type=script&lang=js&"
export * from "./Home_advice_lg.vue?vue&type=script&lang=js&"
import style0 from "./Home_advice_lg.vue?vue&type=style&index=0&id=01469cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01469cf0",
  null
  
)

export default component.exports